export default () => {
    const extensions = map => {
        return {
            async onSetNodeData (node, oldData) {
                const _n = this.nodeProxy(node)
                await _n.emitEventUp({detail: oldData, type: 'change'})
            },
        }
    }

    return {extensions}
}
